import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProductContext from '../ProductContext';
var Wrapper = styled.div.withConfig({
  displayName: "ProductCell__Wrapper",
  componentId: "sc-1v50qsl-0"
})([""]);
var ProductCell = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var children = _ref.children,
      product = _ref.product,
      rest = _objectWithoutProperties(_ref, ["children", "product"]);

  return /*#__PURE__*/React.createElement(ProductContext, {
    product: product
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({}, rest, {
    ref: ref
  }), children));
});
ProductCell.displayName = 'ProductCell';
ProductCell.propTypes = {
  children: PropTypes.node,
  product: PropTypes.object
};
export default ProductCell;